import {TaskFormInput} from '@dms/features/tasks';

import {getApiDateString, parseDate} from 'shared/web';

export function getCreateTaskDefaultValues(date: Date): TaskFormInput {
  const dueFrom = parseDate(date);
  dueFrom.setHours(dueFrom.getHours()); // eslint-disable-line eag/no-native-date-math -- Pre-existing native Date math, migrate to date-fns when possible
  dueFrom.setMinutes(0); // eslint-disable-line eag/no-native-date-math -- Pre-existing native Date math, migrate to date-fns when possible
  dueFrom.setSeconds(0); // eslint-disable-line eag/no-native-date-math -- Pre-existing native Date math, migrate to date-fns when possible
  const dueTo = parseDate(date);
  dueTo.setHours(dueTo.getHours() + 1); // eslint-disable-line eag/no-native-date-math -- Pre-existing native Date math, migrate to date-fns when possible
  dueTo.setMinutes(0); // eslint-disable-line eag/no-native-date-math -- Pre-existing native Date math, migrate to date-fns when possible
  dueTo.setSeconds(0); // eslint-disable-line eag/no-native-date-math -- Pre-existing native Date math, migrate to date-fns when possible

  return {
    dueDate: getApiDateString(date),
    dueFrom: dueFrom.toISOString(),
    dueTo: dueTo.toISOString(),
  };
}
